import { emit } from "@tauri-apps/api/event";
import { isTauri } from "@/lib/is-tauri";

export const NARRATION_STATE_EVENT = "denker://narration-state";

export type NarrationState = "started" | "finished" | "cancelled" | "error";

export interface NarrationStateDetail {
  utteranceId: string;
  text: string;
  state: NarrationState;
  provider: "system" | "denker";
  ttsSource?: string;
  executionId?: string;
  presentationAttemptCancelled?: boolean;
  speechInterruptedByUser?: boolean;
  at: number;
}

const presentationStates = new Map<string, NarrationStateDetail>();

export function replayPresentationNarration(source: string): void {
  const detail = presentationStates.get(source);
  if (detail) emitNarrationState({ ...detail, at: Date.now() });
}

export function emitNarrationState(detail: NarrationStateDetail): void {
  if (detail.ttsSource?.startsWith("presentation:")) {
    presentationStates.set(detail.ttsSource, detail);
    if (presentationStates.size > 512)
      presentationStates.delete(presentationStates.keys().next().value!);
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent<NarrationStateDetail>(NARRATION_STATE_EVENT, {
        detail,
      }),
    );
  }
  if (isTauri()) {
    void emit(NARRATION_STATE_EVENT, detail).catch(() => {});
  }
}
